import React, { FC } from 'react'
import { createPortal } from 'react-dom'
import { makeStyles } from '@material-ui/core/styles'
import { color, fontFamily } from './tokens'
import { useBannerSlot } from './banner-slot'

// Slim full-width bar in the mock's palette: amber (warning/15) or red (destructive/15).
const useBannerStyles = makeStyles({
  root: {
    position: 'relative',
    zIndex: 5,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    minHeight: 40,
    padding: '4px 24px',
    boxSizing: 'border-box',
    color: color.foreground,
    fontFamily,
    fontSize: 14,
    lineHeight: '20px'
  },
  warning: { backgroundColor: color.warning15 },
  destructive: { backgroundColor: color.destructive15 },
  text: { margin: 0 }
})

interface BannerProps {
  tone: 'warning' | 'destructive'
  message: string
}

export const Banner: FC<BannerProps> = ({ tone, message, children }) => {
  const classes = useBannerStyles()
  const slot = useBannerSlot()
  const bar = (
    <div
      className={`${classes.root} ${classes[tone]}`}
      data-tone={tone}
    >
      {/* Only the message is a live region: the buttons beside it are controls, and
          a screen reader should not re-announce their labels when it updates. */}
      <p
        className={classes.text}
        role='status'
      >
        {message}
      </p>
      {children}
    </div>
  )
  // Under the page title bar when the page has one (see banner-slot).
  return slot ? createPortal(bar, slot) : bar
}
